export default class State {
    constructor(name, displayName, options) {
        this.name = name;
        this.displayName = displayName;
        this.navigable = true;
        Object.assign(this, options);
    }
}
